import React from 'react'

const CorporateLogo4: React.FC = () => {
  return (
    <img style={{position: "relative", height: "100%", pointerEvents: "none", userSelect: "none"}} src="/svgs/corporate_logo4.svg" alt="corporate_logo4"/>
  )
}

export default CorporateLogo4